import { useEffect, useState } from "react";
import { HttpHeaders } from "../Common/Constants";
import { configContext } from "../ConfigContext";
export async function fetchAccessData(portalToken) {
    const headers = new Headers();
    // Portal encrypted token API quirk: The token header must be URL encoded
    headers.append(HttpHeaders.guestAccessToken, encodeURIComponent(portalToken));
    const url = `${configContext.PORTAL_BACKEND_ENDPOINT}/api/connectionstring/runtimeproxy/accessinputmetadata`;
    const options = {
        method: "GET",
        headers: headers,
    };
    return fetch(url, options)
        .then((response) => response.json())
        .catch((error) => console.error(error));
}
export function useTokenMetadata(token) {
    const [state, setState] = useState();
    useEffect(() => {
        if (token) {
            fetchAccessData(token).then((response) => setState(response));
        }
    }, [token]);
    return state;
}
